import Button from "@edaz/edazkit/Button/index";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import { observer } from "mobx-react-lite";
import React from "react";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import type { ViewComponent } from "@frui.ts/views/dist";
import { preventDefault, registerView } from "@frui.ts/views/dist";
import TerminateFormSection from "./terminateFormSection";
import TerminatePreviewSectionView from "./terminatePreviewSection";
import TerminateExemptionViewModel from "viewModels/callCenter/search/exemptions/terminateExemption/terminateExemptionViewModel";

const TerminateExemptionView: ViewComponent<TerminateExemptionViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return null;
  }

  return (
    <Modal show={true} onHide={vm.onClose} centered size="lg">
      <Modal.Header closeButton={true}>
        <Modal.Title>{vm.translate("name")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          <Form onSubmit={preventDefault(vm.onSave)}>
            <div style={vm.terminateStep === 1 ? { minHeight: "55vh" } : {}}>
              {vm.terminateStep === 1 && <TerminateFormSection vm={vm} />}
              {vm.terminateStep === 2 && <TerminatePreviewSectionView vm={vm} />}
            </div>
            <ButtonToolbar className="justify-content-center">
              {vm.terminateStep === 2 ? (
                <Button size="sm" onClick={vm.onBack} variant="light">
                  {vm.translateGeneral("back")}
                </Button>
              ) : (
                <Button size="sm" type="reset" onClick={vm.onClose} variant="light">
                  {vm.translateGeneral("cancel")}
                </Button>
              )}
              {vm.terminateStep === 2 ? (
                <Button size="sm" type="submit">
                  {vm.translateGeneral("confirm")}
                </Button>
              ) : (
                <Button size="sm" type="submit">
                  {vm.translateGeneral("continue")}
                </Button>
              )}
            </ButtonToolbar>
          </Form>
        </LoaderOverlay>
      </Modal.Body>
    </Modal>
  );
});

registerView(TerminateExemptionView, TerminateExemptionViewModel);
